<template>
  <div>
    <b-modal :id="modalId" size="lg" @hide="onClose" @show="clean">
      <b-overlay :show="isLoading" spinner-variant="primary" opacity="1">
        <b-card v-if="isCreateMode" header="Identifiants" class="mt-4">
            <b-card-text>
              <b-row>
                <b-col>
                  <label for="username">Nom d'utilisateur</label>
                  <b-form-input
                    id="username"
                    v-model="userContent.username"
                    :state="inputStates.username"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        <label for="first-name">Prénom</label>
        <b-form-input
          id="first-name"
          class="mb-3"
          v-model="userContent.firstName"
        ></b-form-input>

        <label for="last-name">Nom</label>
        <b-form-input
          id="last-name"
          class="mb-3"
          v-model="userContent.lastName"
        ></b-form-input>

        <label for="email">Email</label>
        <b-form-input
          id="email"
          class="mb-3"
          v-model="userContent.email"
        ></b-form-input>

        <label for="phone-number">Téléphone</label>
        <b-form-input
          id="phone-number"
          class="mb-3"
          v-model="userContent.phoneNumber"
        ></b-form-input>

        <b-form-group label="Résidences :" v-slot="{ ariaDescribedby }">
          <b-form-checkbox v-model="allResidencies">
            Toutes les résidences et future résidences
          </b-form-checkbox>
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="userContent.residencies"
            :disabled="allResidencies"
            :options="
              softTenants.map((tenant) => ({
                text: tenant._source.model,
                value: tenant._id,
              }))
            "
            :aria-describedby="ariaDescribedby"
            name="flavour-1"
          ></b-form-checkbox-group>
        </b-form-group>

        <template v-if="isCreateMode">
          <label>Profile</label>
          <b-row>
            <b-col>
              <b-form-select
                v-model="selectedProfile"
                :options="profilesOptions"
                :disabled="!selectedTenant"
                :state="inputStates.profile"
              ></b-form-select
            ></b-col>
          </b-row>
        </template>
      </b-overlay>
      <template v-slot:modal-header>
        <h2 v-if="isCreateMode">Créer un nouvel utilisateur</h2>
        <h2 v-else>
          Utilisateur
          <code>{{ user._source.firstName }} {{ user._source.lastName }}</code>
        </h2>
      </template>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="onClose">Close</b-button>
        <b-button
          type="submit"
          variant="primary"
          v-if="isCreateMode"
          @click="onCreate"
          >Create</b-button
        >
        <b-button type="submit" variant="primary" v-else @click="onUpdate"
          >Save</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'userContentModal',

  props: {
    user: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    profiles: {
      type: Array,
    },
    selectedTenant: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedProfile: null,
      userContent: {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        residencies: [],
      },
      inputStates: {
        tenant: null,
        profile: null,
        username: null,
      },
      modalId: 'user-content-modal',
      allResidencies: false,
    };
  },

  computed: {
    ...mapGetters('tenants', ['softTenants']),
    isCreateMode() {
      return this.user._id ? false : true;
    },
    isFormValid() {
      return (
        !this.isCreateMode ||
        (this.inputStates.profile &&
          this.inputStates.username)
      );
    },
    profilesOptions() {
      return [
        { value: null, text: 'Selectionez un profile' },
        ...this.profiles,
      ];
    },
  },

  methods: {
    onClose() {
      this.$emit('modal-close');
      this.resetState();
      this.$bvModal.hide(this.modalId);
    },
    onUpdate() {
      this.validate();

      if (!this.isFormValid) {
        return;
      }

      this.userContent.canViewAllResidencies = this.allResidencies;

      if (this.allResidencies) {
        this.userContent.residencies = [];
      }

      const payload = {
        _id: this.user._id,
        _source: this.userContent,
      };

      this.$emit('update', payload);
      this.$bvModal.hide(this.modalId);
    },
    onCreate() {
      this.validate();

      if (!this.isFormValid) {
        return;
      }

      this.userContent.canViewAllResidencies = this.allResidencies;

      if (this.allResidencies) {
        this.userContent.residencies = [];
      }

      const payload = {
        tenantId: this.selectedTenant._id || null,
        profile: this.selectedProfile || null,
        content: this.userContent,
      };

      this.$emit('create', payload);
      this.$bvModal.hide(this.modalId);
    },
    clean() {
      if (!this.isCreateMode) {
        // Do not clean the form
        // if we are in edit mode
        return;
      }
      this.userContent = {
        username: null,
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        residencies: [],
      };
      this.selectedProfile = null;
    },
    resetState() {
      this.inputStates = {
        tenant: null,
        profile: null,
        username: null,
      };
    },
    validate() {
      this.resetState();

      if (this.isCreateMode) {
        this.inputStates.username = this.userContent.username ? true : false;
        this.inputStates.profile = this.selectedProfile ? true : false;
      }
    },
  },
  watch: {
    user(value) {
      if (!this.isCreateMode && value) {
        this.userContent = {
          firstName: value._source.firstName || null,
          lastName: value._source.lastName || null,
          email: value._source.email || null,
          phoneNumber: value._source.phoneNumber || null,
          residencies: value._source.residencies || [],
        };
      }
    },
  },
};
</script>

<style>
.tenant-badge {
  font-size: 1rem;
}
</style>
